<template>
  <v-dialog v-model="dialog" max-width="500px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" text small>
        <v-icon left>mdi-plus</v-icon> add variant
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Create variant</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" class="py-0">
              <v-autocomplete
                clearable
                v-model="productReference"
                :items="products"
                :loading="isLoading"
                :search-input.sync="searchProducts"
                item-text="name"
                outlined
                @click:clear="debounceSearch"
                :placeholder="
                  `Search for reference (${$store.state.globalBrand.name ||
                    'brands'}'s products)`
                "
                prepend-inner-icon="mdi-database-search"
                return-object
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" class="py-0">
              <v-text-field
                clearable
                outlined
                label="Ean"
                v-model="variant.ean"
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="py-0">
              <v-text-field
                clearable
                outlined
                label="Name"
                v-model="variant.name"
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="py-0">
              <v-text-field
                clearable
                outlined
                number
                label="Year"
                v-model="variant.year"
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="py-0">
              <v-text-field
                clearable
                outlined
                label="Price"
                v-model="variant.price"
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="py-0">
              <v-select
                clearable
                v-model="variant.currency"
                :items="currencyList"
                item-text="display"
                item-value="code"
                outlined
                :loading="isLoadingCurrencies"
                placeholder="Currency"
              >
              </v-select>
            </v-col>
            <v-col cols="12" class="py-0">
              <v-text-field
                clearable
                outlined
                type="number"
                label="size"
                v-model="variant.bottle_size"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="dialog = false">
          Close
        </v-btn>
        <v-btn @click="save" color="blue darken-1" text>
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { CatalogService, DatasetService } from "@/services"
import { CURRENCIES } from "@/data"
import { debounce, isEmpty } from "lodash"
export default {
  data() {
    return {
      products: [],
      currencyList: [],
      searchProducts: "",
      isLoading: false,
      isLoadingCurrencies: false,
      productReference: null,
      variantModel: {
        product_id: null,
        ean: "",
        image: "",
        name: "",
        bottle_size: "",
        price: "",
        currency: "",
        year: ""
      },
      variant: null,
      dialog: false
    }
  },
  mounted() {
    this.getProducts()
    this.getCurrencies()
  },
  created() {
    this.variant = this.lo.cloneDeep(this.variantModel)
  },
  watch: {
    productReference(nv, ov) {
      if (nv)
        this.variant = {
          ...this.variant,
          name: nv.name,
          bottle_size: nv.bottle_size,
          price: nv.price,
          currency: nv.currency,
          year: nv.year
        }
    },
    searchProducts(newValue, oldValue) {
      const $ = this
      $.debounceSearch()
    }
  },
  methods: {
    close() {
      this.dialog = false
      this.variant = this.lo.cloneDeep(this.variantModel)
    },
    debounceSearch: debounce(function() {
      this.getProducts()
    }, 400),
    getCurrencies() {
      this.isLoadingCurrencies = true

      DatasetService.get(
        this,
        this.$HMD.constants.CURRENCIES_DATASET_UID,
        {},
        []
      )
        .then(r => {
          this.currencyList = r.data
        })
        .catch(err => {
          this.currencyList = CURRENCIES
        })
        .finally(() => {
          this.isLoadingCurrencies = false
        })
    },
    getProducts() {
      this.isLoading = true
      CatalogService.list(this, {
        ...(!isEmpty(this.searchProducts)
          ? { name: "%25" + this.searchProducts.toLowerCase() + "%25" }
          : {})
      })
        .then(r => {
          this.products = r.results
        })
        .finally(() => {
          this.isLoading = false
        })
      // DatasetService.get(
      //   this,
      //   this.$HMD.constants.PRODUCTS_DATASET_UID,
      //   {
      //     filter: [
      //       {
      //         field_name: "name",
      //         is_filtered: true,
      //         query: {
      //           operator: "icontains",
      //           values: [this.searchProducts]
      //         }
      //       },
      //       {
      //         field_name: "brand_id",
      //         is_filtered: true,
      //         query: {
      //           operator: "in",
      //           values: [this.$store.state.globalBrand.id]
      //         }
      //       }
      //     ]
      //   },
      //   []
      // )
      //   .then(r => {
      //     this.products = r.data
      //   })
      //   .finally(() => {
      //     this.isLoading = false
      //   })
    },
    save() {
      this.$emit("created", this.variant)
      this.close()
      // this.dialog = false
    }
  }
}
</script>

<style lang="scss" scoped></style>
